import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignsActivity } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignActivity, CampaignsActivitySlice } from "types/campaign/activity";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";

export const fetchCampaignsActivityThunk = createAsyncThunk<{count: number, items: CampaignActivity[], filters: { page: number, [key: string]: any }, filterId: string}, {filters: { page: number, [key: string]: any }, force?: boolean}, {rejectValue: string}>(
    'campaigns/activity',
    async({filters, force}, {getState, rejectWithValue}) => {
        try {
            const state = getState() as { auth: AuthState, campaignsActivity: CampaignsActivitySlice };
            const filterId = generateUniqueKey(filters, ['page']);
            const STALE_TIME = apiConfig.FETCH_CAMPAIGNS_ACTIVITY.staleTime;

            if(filters.page === 1 && !force && isFresh(state.campaignsActivity?.filtered_lists?.[filterId]?.last_fetched_at, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED);
            }
            const { count, items } = await fetchCampaignsActivity({...filters,limit: filters.limit ?? 24});

            return {count, items, filters, filterId}

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collaboration!"));
        }
    }
)